// Copyright (c) 2020 Deere & Company

import TabmWipContainer from '../../tabm/wip';
import spaDetails from './spa';

export default {
    childRoutes: [
        spaDetails
    ],
    component: TabmWipContainer,
    name: 'WIP',
    path: 'wip'
};




// WEBPACK FOOTER //
// ./src/routes/tabm/wip.js